
/**
 * Smoothly scrolls to a specific element on the page
 * @param elementId The ID of the element to scroll to
 */
export const scrollToElement = (elementId: string): void => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

/**
 * Navigates to the home page and scrolls to a specific section
 * @param elementId The ID of the element to scroll to
 */
export const navigateAndScrollTo = (elementId: string): void => {
  // Check if we're already on the home page
  if (window.location.pathname === '/') {
    scrollToElement(elementId);
  } else {
    // Navigate to home page with a hash to trigger scrolling after page load
    window.location.href = `/#${elementId}`;
  }
};
